var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _rect3, _path7, _rect4, _rect5, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCulture06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.458984,
    y: 0.226562,
    width: 350,
    height: 233,
    fill: "#2E4491"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.267 64.1751C258.439 64.0487 258.646 63.9805 258.86 63.9805H263.002C263.216 63.9805 263.424 64.0489 263.596 64.1756L308.525 97.3033C308.78 97.4918 308.931 97.7906 308.931 98.1082V101.382C308.931 101.934 308.483 102.382 307.931 102.382H213.932C213.379 102.382 212.932 101.934 212.932 101.382V98.0441C212.932 97.7262 213.083 97.4272 213.339 97.2387L258.267 64.1751Z",
    fill: "#E7E6F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.77 64.3086L308.932 97.6587V102.437H280.132V97.5941L263.77 64.3086Z",
    fill: "#ABA9C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 217.732,
    y: 102.387,
    width: 86.3995,
    height: 4.80016,
    rx: 1,
    fill: "#E7E6F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.732 102.387H304.132V104.787H217.732V102.387Z",
    fill: "#ABA9C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.732 146.582C217.732 146.03 218.18 145.582 218.732 145.582H303.132C303.684 145.582 304.132 146.03 304.132 146.582V150.382H217.732V146.582Z",
    fill: "#4841A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241.73 145.582H303.13C303.682 145.582 304.13 146.03 304.13 146.582V150.382H280.13L241.73 145.582Z",
    fill: "#353071"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 151.379C212.932 150.827 213.379 150.379 213.932 150.379H307.931C308.483 150.379 308.931 150.827 308.931 151.379V158.979C308.931 159.532 308.483 159.979 307.931 159.979H213.932C213.379 159.979 212.932 159.532 212.932 158.979V151.379Z",
    fill: "#E7E6F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 222.531,
    y: 107.188,
    width: 19.1999,
    height: 38.4013,
    fill: "#E7E6F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.531 107.188H241.731V133.588L222.531 116.788V107.188Z",
    fill: "#ABA9C8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 251.332,
    y: 107.188,
    width: 19.1999,
    height: 38.4013,
    fill: "#E7E6F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 280.133,
    y: 107.188,
    width: 19.1999,
    height: 38.4013,
    fill: "#E7E6F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M251.332 107.188H270.532V133.588L251.332 116.788V107.188Z",
    fill: "#ABA9C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M280.133 107.188H299.333V133.588L280.133 116.788V107.188Z",
    fill: "#ABA9C8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture06);
export default __webpack_public_path__ + "static/media/culture_06.506e78456d757ea4017ea4c676cec419.svg";
export { ForwardRef as ReactComponent };